var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32546 7.08333C3.43379 6.59167 2.82546 6.08333 2.82546 5.29167C2.82546 4.38333 3.66712 3.75 5.07546 3.75C6.55879 3.75 7.10879 4.45833 7.15879 5.5H9.00045C8.94212 4.06667 8.06712 2.75 6.32546 2.325V0.5H3.82546V2.3C2.20879 2.65 0.908789 3.7 0.908789 5.30833C0.908789 7.23333 2.50046 8.19167 4.82546 8.75C6.90879 9.25 7.32546 9.98333 7.32546 10.7583C7.32546 11.3333 6.91712 12.25 5.07546 12.25C3.35879 12.25 2.68379 11.4833 2.59212 10.5H0.758789C0.858789 12.325 2.22546 13.35 3.82546 13.6917V15.5H6.32546V13.7083C7.95046 13.4 9.24212 12.4583 9.24212 10.75C9.24212 8.38333 7.21712 7.575 5.32546 7.08333Z",
    fill: "#4C5C68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.aa7f34d5e249e575af9c2152af6a22cc.svg";
export { ForwardRef as ReactComponent };